import type { ReactNode } from 'react'
import Box from '@mui/material/Box'
import type { SxProps, Theme } from '@mui/material/styles'
import {
  surveyCheckboxListSx,
  surveyChoiceListGridSx,
  surveyChoiceListHorizontalSx,
} from '../../../styles/surveyExecutionStyles'

interface ChoiceOptionLayoutProps {
  readonly layoutHorizontal: boolean
  readonly multiColumn: boolean
  readonly children: ReactNode
  readonly 'data-testid'?: string
}

export function ChoiceOptionLayout({
  layoutHorizontal,
  multiColumn,
  children,
  'data-testid': testId,
}: ChoiceOptionLayoutProps) {
  let sx: SxProps<Theme> = surveyCheckboxListSx
  if (layoutHorizontal && multiColumn) {
    sx = surveyChoiceListGridSx
  } else if (layoutHorizontal) {
    sx = surveyChoiceListHorizontalSx
  }

  return (
    <Box sx={sx} data-testid={testId}>
      {children}
    </Box>
  )
}
